import clientConfigurationProvider from "../../../providers/clientConfigurationProvider";
import webContextProvider from "../../../providers/webContextProvider";
import { SAVED_LISTS } from "../../../../constants";
import global from "global";

const isBackInStockNotificationEnabled = () => {
  const { backInStockNotificationEnabledStores, siteRootPath } =
    clientConfigurationProvider();

  if (
    !new RegExp(`^${siteRootPath}${SAVED_LISTS}/`).test(
      global.location.pathname
    )
  ) {
    return false;
  }

  const { storeId } = webContextProvider();

  return backInStockNotificationEnabledStores.includes(storeId);
};

export default isBackInStockNotificationEnabled;
